export default __webpack_public_path__ + "static/media/sa.97b6fd07.svg";